import { useMemo } from 'react';
import I18n from 'I18n';
import MenuBar from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { aggregateOptionsById, flattenOptionsToList, getAllShortcutOptions } from 'automation-ui-canvas/components/flow-header/menu-bar/utils/menuItemUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateFlowMenuBar = ({
  flow,
  canvasScrollElementRef
}) => {
  const TopLevelMenuOptions = useMemo(() => [{
    id: 'file',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.file'),
    options: [],
    disabled: true
  }, {
    id: 'edit',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.edit'),
    options: [],
    disabled: true
  }, {
    id: 'settings',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.settings'),
    disabled: true
  }, {
    id: 'view',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.view'),
    options: [],
    disabled: true
  }, {
    id: 'help',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.help'),
    options: [],
    disabled: true
  }], []);
  const AllMenuOptionsById = useMemo(() => aggregateOptionsById(TopLevelMenuOptions), [TopLevelMenuOptions]);
  const AllMenuOptionsList = useMemo(() => flattenOptionsToList(TopLevelMenuOptions), [TopLevelMenuOptions]);
  const AllShortcutOptions = getAllShortcutOptions(AllMenuOptionsList);
  return /*#__PURE__*/_jsx(MenuBar, {
    flow: flow,
    canvasScrollElementRef: canvasScrollElementRef,
    allMenuOptionsById: AllMenuOptionsById,
    topLevelMenuOptions: TopLevelMenuOptions,
    shortcutOptions: AllShortcutOptions
  });
};
export default CreateFlowMenuBar;